<div [ngStyle]="{ 'background-color': color }" class="toastr-class">
    @if (isIconShown) {
        <span class="icon-success"><img [src]="iconSource" alt="toast-icon" /></span>
    }
    <span id="toast" class="message">{{ message | translate }} </span>
</div>
